/**
 * UI language → locale key for catalog/district/amenity labels.
 * @param {string} [language]
 * @returns {'ko'|'en'|'vi'|'ru'|'ja'|'zh-CN'|'zh-TW'|'hi'|'th'|'id'}
 */
export function normalizeLangKey(language) {
  const code = String(language || 'ko').toLowerCase();
  if (code.startsWith('en')) return 'en';
  if (code.startsWith('vi')) return 'vi';
  if (code.startsWith('ru')) return 'ru';
  if (code.startsWith('ja')) return 'ja';
  if (code === 'zh-tw' || code.startsWith('zh-hant') || code === 'zh_tw') return 'zh-TW';
  if (code.startsWith('zh')) return 'zh-CN';
  if (code.startsWith('hi')) return 'hi';
  if (code.startsWith('th')) return 'th';
  if (code.startsWith('id')) return 'id';
  return 'ko';
}

/** BCP 47 tag for native `<input type="date">` locale hints. */
export function dateInputLang(language) {
  const k = normalizeLangKey(language);
  if (k === 'vi') return 'vi-VN';
  if (k === 'ru') return 'ru-RU';
  if (k === 'en') return 'en-US';
  if (k === 'ja') return 'ja-JP';
  if (k === 'zh-CN') return 'zh-CN';
  if (k === 'zh-TW') return 'zh-TW';
  if (k === 'hi') return 'hi-IN';
  if (k === 'th') return 'th-TH';
  if (k === 'id') return 'id-ID';
  return 'ko-KR';
}
